import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { ufService } from '../../services';
import { UF } from '../../types/pessoas';

const columns: ResourceColumn<UF>[] = [
  { header: 'Sigla', accessor: 'sigla' },
  { header: 'Nome', accessor: 'nome' },
  { header: 'IBGE', accessor: 'codigo_ibge' },
];

export const UfsListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Estados (UF)"
      description="Cadastro de unidades federativas."
      columns={columns}
      service={ufService}
      createPath="/admin/pessoas/ufs/novo"
      onEdit={(item) =>
        item.id && navigate('/admin/pessoas/ufs/editar', { state: { record: item } })
      }
      onDelete={(item) => (item.id ? ufService.remove(item.id) : Promise.resolve())}
    />
  );
};
